import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/date-pickers/time-picker/time-picker.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
